export const PALLET_STATUS_STYLE: Record<string, string> = {
  BUILDING: "bg-indigo-50 text-indigo-700 border-indigo-200",
  COMPLETE: "bg-blue-50 text-blue-700 border-blue-200",
  IN_TRANSIT: "bg-amber-50 text-amber-700 border-amber-200",
  BOOKED_IN: "bg-emerald-50 text-emerald-700 border-emerald-200"
};

export const PALLET_STATUS_LABEL: Record<string, string> = {
  BUILDING: "Building",
  COMPLETE: "Complete",
  IN_TRANSIT: "In Transit",
  BOOKED_IN: "Booked In"
};

export const ANIMAL_SKU_MIX_ERROR_MESSAGE = "Cannot mix animal and non-animal cases on the same pallet";

export const ANIMAL_NON_CERTIFIED_MIX_ERROR_MESSAGE =
  "Cannot mix animal-non-certified cases with other cases on the same pallet — these SKUs are kept on dedicated vendor-pure pallets";

export const ANIMAL_NON_CERTIFIED_VENDOR_MIX_ERROR_MESSAGE =
  "Animal-non-certified pallets are vendor-pure — each brand needs its own pallet";

export const NO_LOCATION_AVAILABLE_ERROR_MESSAGE =
  "No pallet locations available. Complete or ship a pallet to free a slot.";
